export default __webpack_public_path__ + "static/media/advisoryimg.b4385db1.png";